import { Box, Col, Row, Text } from '@ksyos/design-system';
import { FormatCurrency } from '@frontend/components/elements/FormatCurrency';
import { getSelectedLanguage } from '@frontend/translate';

interface OrganizationContractSettingsTotalPricePerPatientProps {
    totalPerPatientPerQuarter: number;
}

export function OrganizationContractSettingsTotalPricePerPatient(
    props: Readonly<OrganizationContractSettingsTotalPricePerPatientProps>
) {
    const translate = getSelectedLanguage();

    return (
        <Row>
            <Col span={9}>
                <Box minHeight="40px">
                    <Text
                        fontWeight="medium"
                        pt={2}
                    >
                        {translate.contractSettings.totalPerPatientPerQuarter}
                    </Text>
                </Box>
            </Col>
            <Col span={2}>
                <Box minHeight="40px">
                    <Text
                        aria-label="totaal per patiënt per kwartaal"
                        fontWeight="medium"
                        pt={2}
                    >
                        <FormatCurrency
                            maximumFractionDigits={4}
                            value={props.totalPerPatientPerQuarter}
                            valueIsDecimal={true}
                        />
                    </Text>
                </Box>
            </Col>
        </Row>
    );
}
